/**
 * 安全复制文本到剪贴板。
 *
 * `navigator.clipboard` 仅在「安全上下文」(HTTPS 或 localhost) 下存在;
 * 通过 LAN IP / 域名走 HTTP 访问时它是 `undefined`,直接读取 `.writeText`
 * 会**同步抛错** `Cannot read properties of undefined (reading 'writeText')`,
 * 此时 `.then(...).catch(...)` 也无法兜住(throw 发生在 Promise 创建之前)。
 *
 * 本函数优先用 Clipboard API,不可用 / 被拒绝时回退到 legacy `execCommand('copy')`,
 * 两条路径都失败时返回 `false`,**绝不抛错**。
 *
 * @returns 复制是否成功
 */
export async function copyToClipboard(text: string): Promise<boolean> {
  // 优先:Clipboard API(安全上下文)
  if (typeof navigator !== 'undefined' && navigator.clipboard?.writeText) {
    try {
      await navigator.clipboard.writeText(text)
      return true
    } catch {
      // 权限拒绝 / 非安全上下文 — 落到 legacy 回退
    }
  }
  return legacyCopy(text)
}

/** 回退:借临时 textarea + `execCommand('copy')`(非安全上下文 / 老浏览器)。 */
function legacyCopy(text: string): boolean {
  if (typeof document === 'undefined' || typeof document.execCommand !== 'function') {
    return false
  }
  let textarea: HTMLTextAreaElement | null = null
  try {
    textarea = document.createElement('textarea')
    textarea.value = text
    // 移出视口,避免滚动 / 聚焦抖动
    textarea.style.position = 'fixed'
    textarea.style.top = '-9999px'
    textarea.style.left = '-9999px'
    textarea.setAttribute('readonly', '')
    document.body.appendChild(textarea)
    textarea.select()
    return document.execCommand('copy')
  } catch {
    return false
  } finally {
    if (textarea?.parentNode) textarea.parentNode.removeChild(textarea)
  }
}
